import { useState, useContext, useEffect } from "react";
import styles from "../Filter/FilterModal.module.css";
import { FilterExpiredProductContext } from "../../../context/FilterExpiredProductContext";
import { getUsersByStore } from '../../../hooks/User';

const Modal = ({ closeModal }) => {
  const { 
    isUserNameSelected,
    isBarCodeSelected,
    isProductNameSelected,
    isManufacturerSelected,
    isGroupSelected,
    isLotSelected,
    isExpirationDateSelected,
    isDaysToExpireSelected,
    isStatusProductSelected,
    isProductQuantitySelected,
    isProductSoldSelected,
    isLostProductSelected,
    isProductBalanceSelected,
    isProductLocationSelected,
    resetState, 
    filterData, 
    setFilterData,
    setIsFilter,
    storeId
  } = useContext(FilterExpiredProductContext);

  const [users, setUsers] = useState([]);
  const [userIds, setUserIds] = useState(filterData?.userIds || []);
  const [barcode, setBarcode] = useState(filterData?.barcode || null);
  const [name, setName] = useState(filterData?.name || null);
  const [manufacturer, setManufacturer] = useState(filterData?.manufacturer || null);
  const [lot, setLot] = useState(filterData?.lot || null);
  const [expirationDate, setExpirationDate] = useState(filterData?.expirationDate || null);
  const [group, setGroup] = useState(filterData?.group || null);
  const [selectedColors, setSelectedColors] = useState(filterData?.statusColors || []);
  const [location, setLocation] = useState(filterData?.location || null);
  const [minDaysToExpire, setMinDaysToExpire] = useState(filterData?.daysToExpire?.min || null);
  const [maxDaysToExpire, setMaxDaysToExpire] = useState(filterData?.daysToExpire?.max || null);
  const [minQuantity, setMinQuantity] = useState(filterData?.quantity?.min || null);
  const [maxQuantity, setMaxQuantity] = useState(filterData?.quantity?.max || null);
  const [minQuantityLost, setMinQuantityLost] = useState(filterData?.quantityLost?.min || null);
  const [maxQuantityLost, setMaxQuantityLost] = useState(filterData?.quantityLost?.max || null);
  const [minQuantitySold, setMinQuantitySold] = useState(filterData?.quantitySold?.min || null);
  const [maxQuantitySold, setMaxQuantitySold] = useState(filterData?.quantitySold?.max || null);
  const [minBalance, setMinBalance] = useState(filterData?.balance?.min || null);
  const [maxBalance, setMaxBalance] = useState(filterData?.balance?.max || null);

  const filterDataRequest = {
    storeId : storeId,
    userIds : userIds,
    barcode : barcode,
    name : name,
    manufacturer : manufacturer,
    lot : lot,
    expirationDate : expirationDate,
    daysToExpire : {
      min:minDaysToExpire,
      max:maxDaysToExpire
    },
    group: group,
    quantity: {
      min:minQuantity,
      max:maxQuantity 
    },
    quantityLost: {
      min:minQuantityLost,
      max:maxQuantityLost 
    },
    quantitySold : {
      min:minQuantitySold,
      max:maxQuantitySold 
    },
    balance : {
      min:minBalance,
      max:maxBalance 
    },
    statusColors : selectedColors,
    location : location
};

  const handleCheckboxChange = ( color ) => {
    if (color === "all") {
      setSelectedColors(selectedColors.length === 3 ? [] : ["green", "yellow", "red"]);
    } else {
      setSelectedColors((prevColors) =>
        prevColors.includes(color)
          ? prevColors.filter((c) => c !== color)
          : [...prevColors, color]
      );
    }
  };

  useEffect(() => { fetchUsers()},[])
  const fetchUsers = async () => {
    try {
        const response = await getUsersByStore( storeId );
        if (response?.data?.users) {
            const filteredUsers = response.data.users.filter(user => user.role === "APP_USER");
            setUsers(filteredUsers);
        } else {
            console.error("Failed to fetch users or no users found.");
        }
    } catch (error) {
        console.error("Error fetching users:", error);
    }
};

  const resetSelectedFilter = () => {
    closeModal()
    resetState()
  }

  const onFilterClick = async () => {
    setFilterData(filterDataRequest)
    setIsFilter(true)
    resetSelectedFilter()
  };

  const renderUserNameForm = () => {
    const workers = users
    const allSelected = userIds.length === (workers?.length || 0);
    const handleUserCheckboxChange = (id) => {
      setUserIds((prevUserIds) =>
        prevUserIds.includes(id)? prevUserIds.filter((userId) => userId !== id) : [...prevUserIds, id]
      );
    };
    const handleSelectAll = () => {
      setUserIds(allSelected ? [] : workers.map((worker) => worker.id));
    };
    return (
      <form className={styles.formContainer}>
        <p>Colaboradores</p>
        <div className={styles.checkboxContainer}>
          <div className={styles.checkboxWrapper}>
            <input
              type="checkbox"
              checked={allSelected}
              onChange={handleSelectAll}
              className={styles.checkbox}
            />
            <span>Selecionar todos</span>
          </div>
          { workers.map(({ id, name }) => (
            <div key={id} className={styles.checkboxWrapper}>
              <input
                type="checkbox"
                checked={userIds.includes(id)}
                onChange={() => handleUserCheckboxChange(id)}
                className={styles.checkbox}
              />
              <span>{name}</span>
            </div>
          ))}
        </div>
      </form>
    );
  };

  const renderStatusColorForm = () => {
    return (
      <form className={styles.formContainer}>
        <p>Status</p>
        <div className={styles.checkboxContainer}>
        {[
          { id: "all", label: "Selecionar tudo" },
          { id: "green", label: "Verde" },
          { id: "yellow", label: "Amarelo" },
          { id: "red", label: "Vermelho" },
        ].map(({ id, label }) => (
          <div key={id} className={styles.checkboxWrapper}>
            <input
              type="checkbox"
              checked={id === "all" ? selectedColors.length === 3 : selectedColors.includes(id)}
              onChange={() => handleCheckboxChange(id)}
              className={styles.checkbox}
            />
            <span>{label}</span>
          </div>
        ))}
      </div>
      </form>
    );
  };

  const renderBarcodeForm = () => {
    return (
      <form>
        <p>Código de Barras</p>
  
        <input
          type="text"
          value={ barcode }
          onChange={(e) => setBarcode(e.target.value)}
          placeholder="Digite o código de barras"
          className={styles.textField}
        />
      </form>
    );
  };

  const renderProductNameForm = () => {
    return (
      <form>
        <p>Nome do Produto</p>
  
        <input
          type="text"
          value={ name }
          onChange={(e) => setName(e.target.value)}
          placeholder="Digite o nome do produto"
          className={styles.textField}
        />
      </form>
    );
  };

  const renderManufacturer = () => {
    return (
      <form>
        <p>Fabricante</p>
  
        <input
          type="text"
          value={ manufacturer }
          onChange={(e) => setManufacturer(e.target.value)}
          placeholder="Digite o fabricante"
          className={styles.textField}
        />
      </form>
    );
  };

  const renderGroup = () => {
    return (
      <form>
        <p>Grupo</p>
  
        <input
          type="text"
          value={ group }
          onChange={(e) => setGroup(e.target.value)}
          placeholder="Digite o grupo"
          className={styles.textField}
        />
      </form>
    );
  };

  const renderProductLot = () => {
    return (
      <form>
        <p>Lote</p>
  
        <input
          type="text"
          value={ lot }
          onChange={(e) => setLot(e.target.value)}
          placeholder="Digite o lote do produto"
          className={styles.textField}
        />
      </form>
    );
  };

  const renderExpirationDate = () => {
    return (
      <form>
        <p>Data de validade</p>
  
        <input
          type="text"
          value={ expirationDate }
          onChange={(e) => setExpirationDate(e.target.value)}
          placeholder="Ex: 26/03/2025"
          className={styles.textField}
        />
      </form>
    );
  };

  const renderDaysToExpire = () => {
    return (
      <form>
        <p>Dias para vencer</p>
        
        <div className={styles.rangeContainer}>
          <input
            type="text"
            value={minDaysToExpire}
            onChange={(e) => setMinDaysToExpire(e.target.value)}
            placeholder="Mínimo"
            className={styles.textField}
          />
          <span>-</span>
          <input
            type="text" 
            value={ maxDaysToExpire }
            onChange={(e) => setMaxDaysToExpire(e.target.value)}
            placeholder="Máximo"
            className={styles.textField}
          />
        </div>
    </form>

    );
  };

  const renderProductQuantity = () => {
    return (
      <form>
        <p>Quantidade</p>
  
        <div className={styles.rangeContainer}>
          <input
            type="text"
            value={minQuantity}
            onChange={(e) => setMinQuantity(e.target.value)}
            placeholder="Mínimo"
            className={styles.textField}
          />
          <span className={styles.separator}>-</span>
          <input
            type="text"
            value={maxQuantity}
            onChange={(e) => setMaxQuantity(e.target.value)}
            placeholder="Máximo"
            className={styles.textField}
          />
        </div>
      </form>
    );
  };

  const renderProductQuantitySold = () => {
    return (
      <form>
        <p>Quantidade vendida</p>
  
        <div className={styles.rangeContainer}>
          <input
            type="text"
            value={minQuantitySold}
            onChange={(e) => setMinQuantitySold(e.target.value)}
            placeholder="Mínimo"
            className={styles.textField}
          />
          <span className={styles.separator}>-</span>
          <input
            type="text"
            value={maxQuantitySold}
            onChange={(e) => setMaxQuantitySold(e.target.value)}
            placeholder="Máximo"
            className={styles.textField}
          />
        </div>
      </form>
    );
  };

  const renderProductQuantityLost = () => {
    return (
      <form>
        <p>Quantidade perdida</p>
  
        <div className={styles.rangeContainer}>
          <input
            type="text"
            value={minQuantityLost}
            onChange={(e) => setMinQuantityLost(e.target.value)}
            placeholder="Mínimo"
            className={styles.textField}
          />
          <span className={styles.separator}>-</span>
          <input
            type="text"
            value={maxQuantityLost}
            onChange={(e) => setMaxQuantityLost(e.target.value)}
            placeholder="Máximo"
            className={styles.textField}
          />
        </div>
      </form>
    );
  };

  const renderProductBalance = () => {
    return (
      <form>
        <p>Saldo do produto</p>
  
        <div className={styles.rangeContainer}>
          <input
            type="text"
            value={minBalance}
            onChange={(e) => setMinBalance(e.target.value)}
            placeholder="Mínimo"
            className={styles.textField}
          />
          <span className={styles.separator}>-</span>
          <input
            type="text"
            value={maxBalance}
            onChange={(e) => setMaxBalance(e.target.value)}
            placeholder="Máximo"
            className={styles.textField}
          />
        </div>
      </form>
    );
  };

  const renderProductLocation = () => {
    return (
      <form>
        <p>Localização</p>
  
        <input
          type="text"
          value={ location }
          onChange={(e) => setLocation(e.target.value)}
          placeholder="Digite a localização"
          className={styles.textField}
        />
      </form>
    );
  };

  return (
    <div className={styles.modalBackground}>
      <div className={styles.modalContainer}>
        <div className={styles.content}>
          <p  className={styles.filtersTitle}>Filtros</p>
          { isUserNameSelected && renderUserNameForm() }
          { isBarCodeSelected && renderBarcodeForm() }
          { isProductNameSelected && renderProductNameForm() }
          { isManufacturerSelected && renderManufacturer() }
          { isGroupSelected && renderGroup() }
          { isLotSelected && renderProductLot() }
          { isExpirationDateSelected && renderExpirationDate() }
          { isDaysToExpireSelected && renderDaysToExpire() }
          { isStatusProductSelected && renderStatusColorForm()}
          { isProductQuantitySelected && renderProductQuantity()}
          { isProductSoldSelected && renderProductQuantitySold()}
          { isLostProductSelected && renderProductQuantityLost()}
          { isProductBalanceSelected && renderProductBalance()}
          { isProductLocationSelected && renderProductLocation()}
        </div>
        <div className={styles.buttonContent}>
          <button onClick={ () => onFilterClick() } className={styles.buttonConfirm}>Filtrar</button>
          <button onClick={ resetSelectedFilter } className={styles.buttonCancel}>
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
};

export default Modal;
